import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df3b5c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "title-row" }
const _hoisted_3 = { class: "sn" }
const _hoisted_4 = { class: "xag-flex center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = { class: "buttom-row" }
const _hoisted_10 = {
  key: 0,
  class: "amont"
}
const _hoisted_11 = { key: 1 }

import { useRouter, useRoute } from 'vue-router'
import { List, PullRefresh, Button } from 'vant'
import AppHeader from '@/components/Header.vue'
import useCommonList, { PageListResut } from '@/compositions/useCommonList'
import { XssCommonPageListQuery } from '@/types/public'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import {
  NameplateReissueOrderStatusColorMap,
  NameplateReissueOrderStatusTextMap,
  NameplateReissueOrderSerciceTypeTextMap,
  NameplateReissueOrderButtonTextMap,
} from '@/defination/nameplate-reissue'
import type { NameplateReissueListItem } from '@/types/nameplate-reissue'
import { getNameplateReissueList } from '@/apis/nameplate-reissue'
import {
  NameplateReissueDetail,
  NameplateReissueList,
  NameplateReissueApply,
} from '@/store/nameplate-reissue'
import { clearToast } from '@/utils/tools'
import { onMounted, watch } from 'vue'
import AppHost from '@/utils/app'

import { defineComponent } from 'vue'
import { useStore } from 'vuex'
const __default__ = defineComponent({
  name: 'nameplate-reissue-list',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $store = useStore()
const $router = useRouter()
const $route = useRoute()
async function queryList(
  params: XssCommonPageListQuery
): Promise<PageListResut<NameplateReissueListItem>> {
  try {
    const data = await getNameplateReissueList(params)
    return data
  } catch (error) {
    console.log('error', error)
    return Promise.reject(error)
  }
}
const {
  refreshing,
  loading,
  requestError,
  finished,
  onRefresh,
  dataList,
  queryHandle,
  finishedText,
} = useCommonList<NameplateReissueListItem, any>(queryList, {})

function addHandle() {
  $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueApply)
  $router.push({
    name: 'nameplate-reissue-apply',
  })
}
// 无数据跳转
let isJumpflag = true
watch(
  () => dataList.value,
  () => {
    if (!dataList.value.length && isJumpflag) {
      isJumpflag = false
      addHandle()
    }
  }
)

function goToDetailHandler(item: NameplateReissueListItem) {
  $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueDetail)
  $router.push({
    name: 'nameplate-reissue-detail',
    query: {
      guid: item.guid,
    },
  })
}
onMounted(() => {
  clearToast()
  $store.commit('NameplateReissue/addCacheRouteName', NameplateReissueList)
  // 判断
})

function leftClickHandle() {
  AppHost.goAppBack()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "三证补办申请",
      isReturnLeftEvent: true,
      onLeftClick: leftClickHandle
    }),
    _createVNode(_unref(PullRefresh), {
      modelValue: _unref(refreshing),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
      onRefresh: _unref(onRefresh),
      class: "list-wrap"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(List), {
          loading: _unref(loading),
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
          error: _unref(requestError),
          "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
          finished: _unref(finished),
          offset: 200,
          "finished-text": _unref(finishedText),
          "error-text": "加载失败",
          onLoad: _unref(queryHandle),
          class: "list-container"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "van-hairline--surround list-item",
                onClick: ($event: any) => (goToDetailHandler(item))
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(item.order_no), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", {
                      class: "status",
                      style: _normalizeStyle({ color: _unref(NameplateReissueOrderStatusColorMap).get(item.status) })
                    }, _toDisplayString(_unref(NameplateReissueOrderStatusTextMap).get(item.status)), 5),
                    _hoisted_5
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, "设备序列号：" + _toDisplayString(item.serial_number), 1),
                _createElementVNode("div", _hoisted_7, "补办类型：" + _toDisplayString((item.namplate_types_text || []).join('、')), 1),
                _createElementVNode("div", _hoisted_8, "申请时间：" + _toDisplayString(item.created_at), 1),
                _createElementVNode("div", _hoisted_9, [
                  (item.status !== 20)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["xag-flex center", { 'pd-top-19': _unref(NameplateReissueOrderSerciceTypeTextMap).has(item.service_type) }])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["amount-tip", { 'is-free': item.service_type === 2 }])
                        }, _toDisplayString(_unref(NameplateReissueOrderSerciceTypeTextMap).get(item.service_type)), 3),
                        (item.service_type === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(`￥${item.pay_amount}`), 1))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_unref(NameplateReissueOrderButtonTextMap).has(item.status))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_unref(Button), {
                          type: "success",
                          block: "",
                          round: "",
                          class: "button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(NameplateReissueOrderButtonTextMap).get(item.status)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_1))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "error", "finished", "finished-text", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createVNode(CommonFooterNextButton, {
      onClick: addHandle,
      title: "添加申请"
    })
  ], 64))
}
}

})